import React from 'react';
import { 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Checkbox, 
  Typography, 
  Box // Importe o Box para controlar o overflow
} from '@mui/material';

const FinancialTable = ({ items, onUpdateStatus, type }) => {
  const isDebt = type === 'debt';
  const headers = ['Descrição', 'Valor', isDebt ? 'Credor' : 'Devedor', 'Vencimento', isDebt ? 'Pago' : 'Recebido'];

  // Mensagem para quando a tabela estiver vazia
  if (!items || items.length === 0) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center', boxShadow: 3 }}>
        <Typography color="text.secondary">
          Nenhum item encontrado. Adicione um novo item no formulário acima.
        </Typography>
      </Paper>
    );
  }

  return (
    // ESTA É A MUDANÇA PRINCIPAL PARA RESPONSIVIDADE
    // O Box garante que, se a tabela for muito larga para a tela,
    // uma barra de rolagem horizontal aparecerá, em vez de quebrar o layout.
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Paper sx={{ width: '100%', mb: 2, boxShadow: 3 }}>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="financial table">
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableCell key={header} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => {
                const status = isDebt ? item.paid : item.received;
                const textColor = status ? 'text.disabled' : 'text.primary';

                return (
                  <TableRow 
                    key={item.id} 
                    hover 
                    sx={{ 
                      '&:last-child td, &:last-child th': { border: 0 },
                      backgroundColor: status ? '#fafafa' : 'inherit' // Fundo levemente cinza para itens pagos
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2" color={textColor} sx={{ textDecoration: status ? 'line-through' : 'none' }}>
                        {item.description}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography 
                        variant="body2" 
                        color={status ? 'text.disabled' : (isDebt ? 'error.main' : 'success.main')} 
                        sx={{ textDecoration: status ? 'line-through' : 'none', fontWeight: 600, whiteSpace: 'nowrap' }}
                      >
                        {parseFloat(item.amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color={textColor} sx={{ textDecoration: status ? 'line-through' : 'none' }}>
                        {isDebt ? item.creditor : item.debtor}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color={textColor} sx={{ textDecoration: status ? 'line-through' : 'none', whiteSpace: 'nowrap' }}>
                        {new Date(item.due_date).toLocaleDateString("pt-BR", { timeZone: 'UTC' })}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={status}
                        onChange={(e) => onUpdateStatus(item.id, e.target.checked, type)}
                        color={isDebt ? 'primary' : 'success'}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default FinancialTable;